<template class="overlay-loader-visible">
  <router-view></router-view>
  <notifications-component v-if="isAuthenticated"/>
  <popup-component v-if="isAuthenticated"/>
  <div class="overlay-loader">
    <svg width="100" height="100" viewBox="0 0 38 38" stroke="#f04c24" ><g fill="none" fill-rule="evenodd"><g transform="translate(1 1)" stroke-width="1"><circle stroke="#DBDEE5" cx="18" cy="18" r="18"/><path d="M36 18c0-9.94-8.06-18-18-18"><animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite"/></path></g></g></svg>
  </div>
</template>

<script>

import PopupComponent from "./components/common/Popup";
import { mapGetters, mapState } from "vuex"
import NotificationsComponent from "./components/common/Notifications";

export default {
    name: 'App',
    components: {
        NotificationsComponent,
        PopupComponent
    },
    computed: {
        ...mapState('user', [
            'company',
            'accountNumber',
        ]),
        ...mapGetters('user', [
            'isAuthenticated',
        ]),
    },
    mounted() {
        //let root = document.getElementsByTagName( 'html' )[0];
        //root.classList.add('no-touchevents')
    },

}
</script>

<style>

</style>
